import { type ReactNode } from 'react'
import { Card } from '../../../shared/components'

interface StatCardProps {
  title: string
  value: string | number | ReactNode
  subtitle?: string
  icon: ReactNode
  iconBgColor?: string
  valueClassName?: string
}

export const StatCard = ({ 
  title, 
  value, 
  subtitle = 'This Month', 
  icon, 
  iconBgColor = 'bg-transparent',
  valueClassName = 'text-foreground'
}: StatCardProps) => {
  return (
    <Card className="p-5 bg-card">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center justify-between mb-1">
            <p className="text-[18px] font-semibold text-foreground leading-[140%]" style={{ fontFamily: "'Open Sans', sans-serif" }}>{title}</p>
            <div className={`w-8 h-8 ${iconBgColor} rounded-lg flex items-center justify-center`}>
              {icon}
            </div>
          </div>
          <p className="text-xs text-muted-foreground mb-1">{subtitle}</p>
          <div className={`text-2xl font-bold ${valueClassName}`}>{value}</div>
        </div>
      </div>
    </Card>
  )
}